module.exports = __webpack_public_path__ + "img/icon_contact_07.5da1e08.svg";